<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.datos_economicos_hidrog.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>

              
              <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSV">
                  {{$t('comun.boton_importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleCSVUpload"
                  />
                </v-btn>
              </v-col>
              


            <!-- <v-col cols="12">
                <v-container>
                  <v-row>      
                    <v-col cols=12>
                      <div id="app2">
                          <v-grid 
                          theme="material" 
                          :source="datos" 
                          :columns="columns"
                          canFocus=true
                            range=true
                            useClipboard=true
                            readonly=false
                            filter=true
                            resize=true    
                            @afteredit="handleCellEdit"                        
                          ></v-grid>      
                      </div>
                    </v-col>      
                  </v-row>
                </v-container>

            </v-col> -->
            </v-row>
        </v-card-text>
   

  <div class="tabla-container">
    <table class="tabla-estilizada">
      <thead>
        <tr>
          <th v-for="col in this.columns" :key="col.prop" :style="{ width: col.size + 'px' }">
            {{ col.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(fila, index) in this.datos.slice(this.first_index,this.last_index)" :key="index">
          <td>{{ fila.anio }}</td>

<td>
  <input 
    :disabled="this.disabled" 
    type="text" 
    :value="formatNumber(Math.round(fila.impcomc * 100*1e6)/1e6)" 
    @input="event => {
      const val = event.target.value.replace(',', '.');
      fila.impcomc = Number(val) / 100;;
      validarCampo(fila, 'impcomc');
    }" 
    class="campo"
  />
</td>

<td>
  <!-- Se devuelve el número porcentual a número sobre 100, y luego se aplica el redondeo a 4 decimales -->
  <input 
    :disabled="this.disabled" 
    type="text" 
    :value="formatNumber(Math.round(fila.ccomv * 100*1e6)/1e6)" 
    @input="event => {
      const val = event.target.value.replace(',', '.');
      fila.ccomv = Number(val) / 100;
      validarCampo(fila, 'ccomv');
    }" 
    class="campo"
  />
</td>

<td>
  <input 
    :disabled="this.disabled" 
    type="text" 
    :value="formatNumber(fila.pgdoe)" 
    @input="event => {
      const val = event.target.value.replace(',', '.');
      fila.pgdoe = Number(val);
      validarCampo(fila, 'pgdoe');
    }" 
    class="campo"
  />
</td>

         <!--  <td><input type="number" v-model.number="fila.preciol" class="campo" /></td> -->
          
          <!-- <td>
            <select v-model="fila.corr" class="select-binario">
              <option :value="1">{{$t('comun.si')}}</option>
              <option :value="0">{{$t('comun.no')}}</option>
              
            </select>
          </td> -->
          <!-- <td><input v-model="fila.preciog" class="campo" /></td> -->
        </tr>
      </tbody>
    </table>
  </div>
</v-card>

</template>

<script>
//import VGrid from "@revolist/vue3-datagrid";
//import axios from 'axios';
//import store from '../store';
//import ComponenteLoading from './ComponenteLoading.vue';
export default {

  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    datos_generales:{
        type:Object,
        required:true,
    },
    disabled:{
      type:Boolean,
      default:false,
    }
  },

  data() {
    return {
      anio_min:2025,
      anio_max:2100,
      loading: false,
      first_index:0,
      last_index:50,
      columns: [
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.anio'),  prop: "anio", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.impcomc'),  prop: "impcomc", size: 250  },
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.ccomv'),  prop: "ccomv", size: 150  },
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.pgdoe'),  prop: "pgdoe", size: 100  },
        //{ name: this.$t('simulacion.modulo.datos_anuales.tabla.precio_limite'),  prop: "preciol", size: 350  },
        //{ name: this.$t('simulacion.modulo.datos_anuales.tabla.correlacion'),  prop: "corr", size: 200  },
        //{ name: this.$t('simulacion.modulo.datos_anuales.tabla.precio_garantia'),  prop: "preciog", size: 250  },
     
    ],

    columnasEsperadas:{
      anio: [this.$i18n.messages.es.simulacion.modulo.datos_economicos_hidrog.tabla.anio, this.$i18n.messages.en.simulacion.modulo.datos_economicos_hidrog.tabla.anio],
      impcomc: [this.$i18n.messages.es.simulacion.modulo.datos_economicos_hidrog.tabla.impcomc, this.$i18n.messages.en.simulacion.modulo.datos_economicos_hidrog.tabla.impcomc],
      ccomv: [this.$i18n.messages.es.simulacion.modulo.datos_economicos_hidrog.tabla.ccomv,this.$i18n.messages.en.simulacion.modulo.datos_economicos_hidrog.tabla.ccomv],
      pgdoe: [this.$i18n.messages.es.simulacion.modulo.datos_economicos_hidrog.tabla.pgdoe, this.$i18n.messages.en.simulacion.modulo.datos_economicos_hidrog.tabla.pgdoe],
    },
      datos:[],


    };
  },

  components: {
    //VGrid,
    //ComponenteLoading,
  },

  watch: {
  /*   modelValue:{
      handler(){
        this.datos= [...this.modelValue]
      },
    deep:true,   
    }, */
    datos_generales:{
        handler(){
            console.log("DESDE HIDROGENO: ", this.datos_generales)
            this.first_index=this.datos_generales.anio_inicio-this.anio_min
            this.last_index=this.datos_generales.anio_fin-this.anio_min+1
        },
        deep:true,
        
    },

    '$i18n.locale'() {     
      
      this.columns= [
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.anio'),  prop: "anio", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.impcomc'),  prop: "impcomc", size: 250  },
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.ccomv'),  prop: "ccomv", size: 150  },
        { name: this.$t('simulacion.modulo.datos_economicos_hidrog.tabla.pgdoe'),  prop: "pgdoe", size: 100  },
        //{ name: this.$t('simulacion.modulo.datos_anuales.tabla.precio_limite'),  prop: "preciol", size: 250  },
        //{ name: this.$t('simulacion.modulo.datos_anuales.tabla.correlacion'),  prop: "corr", size: 250  },
        //{ name: this.$t('simulacion.modulo.datos_anuales.tabla.precio_garantia'),  prop: "preciog", size: 250  },
     
    ];

    },


  },

methods: {
  actualizarDatos(){
    console.log("Actualizar Datos OtrosCostes")
    this.datos=[...this.modelValue]
  },
  formatNumber(value) {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value !== 'number') value = Number(value);

    if (Number.isInteger(value)) {
      return value.toString().replace('.', ',');
    } else {
      return value.toString().replace('.', ',');
    }
  },
    handleCellEdit(event) {
      
      console.log("Intercepta...");

      // Acceder al detalle del evento
      const { detail } = event;

      // Convertir a número si la columna es "valor"
      if (detail.prop === "valor") {
        const newValue = Number(detail.val);

        // Actualizar el modelo de la fila correspondiente
        const rowIndex = detail.rowIndex;
        this.datos[rowIndex][detail.prop] = newValue;

        // Confirmación en consola
        console.log(`Fila actualizada (${rowIndex}):`, this.datos[rowIndex]);
      }
    },


    exportToCSV() {
      const headers = this.columns.map((col) => col.name).join(";");
      const rows = this.datos.slice(this.first_index,this.last_index).map((row) =>
        this.columns.map((col) => {
          const val = row[col.prop];
          if (col.prop === 'ccomv'|| col.prop === 'impcomc') {
            return val !== undefined && val !== null ? (val * 100).toString().replace('.', ',') : '';
          }
          return val !== undefined && val !== null ? val.toString().replace('.', ',') : '';
        }).join(";")
      );

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob(['\uFEFF' + csvContent], {
        type: 'text/csv;charset=utf-8;',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      //Se elige el nombre del archivo según el idioma
      let nombre =  this.$t('simulacion.modulo.datos_economicos_hidrog.titulo')
      nombre = nombre.toLowerCase().replace(/ /g, '_');
      //Para quitar tildes
      nombre=nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      a.download = nombre+".csv";
      a.click();
      URL.revokeObjectURL(url);
    },
    importFromCSV() {
      this.$refs.fileInput.click();
    },
    guess_delimiter(headers) {
      return headers.split(',').length > headers.split(';').length ? ',' : ';';
    },

    verificarClaveEnColumnas(dict){
      let todos=true;
      // Recorremos el diccionario
      Object.keys(dict).forEach(key => {
        // Buscamos si el valor de la clave del dict está dentro de los arrays de columnasEsperadas
        const coincidencia = Object.keys(this.columnasEsperadas).some(columna => {
          return this.columnasEsperadas[columna].some(valor => valor.includes(dict[key].toLowerCase().trim()));
        });

        if (coincidencia) {
          console.log(`La clave "${key}" se encuentra en las columnas esperadas`);
          
        } else {
          console.log(`La clave "${key}" NO se encuentra en las columnas esperadas`);
        }
        todos=todos & coincidencia
      });
      return todos
    },
    devolverPropColumnas(str){
      const propEntry =Object.entries(this.columnasEsperadas).find(([,value ])=> {
        //console.log("Entrada de columnasEsperadas. Key: ", key , " Value:", value)
        //console.log("Value ", key," ",value.join(',') , "Se busca ", str)
        // Buscamos si el valor de la clave del dict está dentro de los arrays de columnasEsperadas
        if (value.some(v => v ==str)) {
          //console.log(`Coincide con la clave: ${key}`);
          return true
        }
        });
        const prop = propEntry ? propEntry[0] : null;
        //console.log("Prop: ", prop);
        return prop;

    },
    //Función para revisar que las cabeceras están en el csv
    revisarCabeceras(header){
      let cabecerasFaltantes=[]
      header.forEach(value=>{
        console.log("Valores de header: ", value)
        if(!this.devolverPropColumnas(value)){
        
          cabecerasFaltantes.push(value)
        }
      })
      console.log("Cabeceras faltantes: ", cabecerasFaltantes)
      //SI existen valores que faltan
      if(cabecerasFaltantes.length>0){
        //codigo de aviso:
        alert( this.$t('mensajes.alerta_cabeceras') +" "+ cabecerasFaltantes.join(', '))
        return true;
      }
      else{
        return false;
      }
    },

    handleCSVUpload(event) {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const csvData = e.target.result;
      const [headerLine, ...lines] = csvData
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0); // Eliminar líneas vacías

      const delim = this.guess_delimiter(csvData.split('\n')[0]);
      console.log("Delimitador: ", delim);

      const header = headerLine.split(delim);
      if (this.revisarCabeceras(header)) {
        return;
      }

      const nuevaLista = lines.map(obj => {
        const values = obj.split(delim);
        const newobj = {};

        header.forEach((header, index) => {
          const value = values[index];
          const cleanValue = value?.replace(',', '.'); // convertir coma en punto
          const prop = this.devolverPropColumnas(header);
          
          // Procesamiento especial para `ccomv`
          if ((prop === 'ccomv' || prop === 'impcomc') && cleanValue !== "" && !isNaN(cleanValue)) {
            newobj[prop] = Number(cleanValue) / 100; // % → PU
          } else if (cleanValue === "" || isNaN(cleanValue)) {
            newobj[prop] = value;
          } else {
            newobj[prop] = Number(cleanValue);
          }
        });

        return newobj;
      });

      const updatedMap = new Map(nuevaLista.map(item => [item.anio, item]));
      const filteredMap = new Map(
        [...updatedMap.entries()].filter(([anio]) => anio >= this.anio_min && anio <= this.anio_max)
      );

      const mergedData = this.datos.map(item =>
        filteredMap.has(item.anio) ? filteredMap.get(item.anio) : item
      );

      this.datos = [...mergedData];
      this.$emit("update:modelValue", this.datos);
    };
    reader.readAsText(file, "UTF-8");
  }
  event.target.value = ""; // Reinicia el valor del input para permitir el mismo archivo
},


  validarCampo(fila, campo) {
  if (fila[campo] < 0) {
    fila[campo] = 0;
    alert(this.$t('El valor no puede ser negativo'));
  }
}
  },
  async mounted(){
    console.log("Datos: ", this.datos)
    this.first_index=this.datos_generales.anio_inicio-this.anio_min
    this.last_index=this.datos_generales.anio_fin-this.anio_min+1

    this.datos=[...this.modelValue]
    
  }
};


</script>

<style scoped>
#app2 {
  height: 400px;
  width: 100%;
}
revo-grid {
  height: 100%;
  width: 100%;
  font-size: 12px;
}

.tabla-container {
  max-width: 100%;
  overflow-x: auto;
  margin-top: 20px;
}

.tabla-estilizada {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.tabla-estilizada th,
.tabla-estilizada td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.tabla-estilizada th {
  background-color: #0078D4;
  font-weight: bold;
  color: white;
}

.tabla-estilizada tr:nth-child(even) {
  background-color: #eef6ff;
}

.tabla-estilizada tr:hover {
  background-color: #8bb6e7;
}




/*
#eef6ff
#bfddf5

*/
.campo,
.select-binario {
  width: 90%;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
}

</style>

